import { CheckCircleOutlined, ExclamationCircleOutlined } from '@ant-design/icons';
import { Alert } from 'antd';
import React from 'react';
import useStores from '@stores/useStores';
import { observer } from 'mobx-react';
import styled from 'styled-components';
import theme from '@css/theme';

const StyledNotification = styled.div`
  z-index: 10000; // highest preference to alert messages
  position: fixed;
  left: 50%;
  margin-left: -200px;
  width: 600px;
  top: 20px;
  color: white;
  padding: 0px;
  z-index: 99999;

  .ant-alert {
    padding: 15px;
    border-radius: 4px;
  }

  .ant-alert-icon {
    color: white;
    margin-right: 15px;
  }

  .ant-alert-content .ant-alert-message {
    color: white;
    font-weight: 500;
  }

  .ant-alert-success {
    background: ${theme.color.success};
    border: 1px solid ${theme.color.success};
  }

  .ant-alert-error {
    background: ${theme.color.error};
    border: 1px solid ${theme.color.error};
  }

  .ant-alert-close-icon {
    margin-left: 15px;
    .anticon-close {
      color: white;
    }
  }
`;

export default observer(() => {
  const { messagesStore } = useStores();
  const handleClose = (type: string) => {
    if (type === 'error') {
      messagesStore.setError(false);
    }
    if (type === 'success') {
      messagesStore.setSuccess(false);
    }
  };
  if (messagesStore.isError) {
    return (
      <StyledNotification>
        <Alert
          message={messagesStore.infoString}
          type="error"
          showIcon
          icon={<ExclamationCircleOutlined style={{ fontSize: '20px' }} />}
          closable
          afterClose={() => handleClose('error')}
        />
      </StyledNotification>
    );
  }

  if (messagesStore.isSuccess) {
    return (
      <StyledNotification>
        <Alert
          message={messagesStore.infoString}
          type="success"
          showIcon
          icon={<CheckCircleOutlined style={{ fontSize: '20px' }} />}
          closable
          afterClose={() => handleClose('success')}
        />
      </StyledNotification>
    );
  }
  return null;
});
